import React, {useContext} from 'react';
import {
  Input,
  FormGroup
} from 'reactstrap';
import {QuestionAnswers} from '../../../../context';

const TextQuestion = (props) => {
  const {text,questionPrompt, handleChange,questionKey, choices} = props
  const rows = Number.isInteger(choices) ? choices : 3

  const {[questionKey]:value=''} = useContext(QuestionAnswers);

  return (
    <div>
      <p>{text}</p>
      <br/>
      {questionPrompt && questionPrompt}
      <FormGroup>
        <Input
          value={value}
          type="textarea"
          rows={rows}
          onChange={e => handleChange(e.target.value)}
        />
      </FormGroup>
    </div>
  );
};

export default TextQuestion;
